<template>
  <el-container>
    <el-header>
      <myHeader></myHeader>
    </el-header>
    <el-main>
      <div class="table-global mar-bottom-10 pad-bottom-0">
      <el-form :inline="true" :model="form" @submit.native.prevent>
        <el-row>
          <el-col :span=17 style="text-align:left">
            <el-form-item label="试卷分类">
              <classify :value.sync="form.flbhList" type="examPaper" :multiple="true"></classify>
              &nbsp;
              <el-button type="success" @click="showDialog = true">筛选</el-button>
            </el-form-item>
            <el-dialog title="选择试卷分类" :visible.sync="showDialog" :append-to-body="true" width="30%" center>
              <classifyTree :value.sync="form.flbhList" type="examPaper" :visible.sync="showDialog"></classifyTree>
            </el-dialog>
            <el-form-item label="">
              <el-input v-model="form.sjmc" style="width:400px" placeholder="请输入试卷名称" @keyup.enter.native="query()"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="query()">查询</el-button>
            </el-form-item>
          </el-col>
          <el-col :span=7 style="text-align: right">
            <el-form-item>
              <el-button type="primary" style="color: white;" @click="toExamPaperAdd">
                <i class="el-icon-plus">&emsp;创建试卷</i>
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="warning" style="color: white;" @click="flglDialogVisible = true">
                试卷分类管理
              </el-button>
              <el-dialog title="编辑分类" :visible.sync="flglDialogVisible" width="40%" center :close-on-click-modal="false">
                <classifyTreeEdit type="examPaper" :visible.sync="flglDialogVisible"></classifyTreeEdit>
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>

      <div class="table-global">
        <el-table :data="tableData" style="width: 100%" :border="true">
          <el-table-column label="试卷名称" width="300">
            <template slot-scope="scope">
              <el-col style="overflow: hidden;white-space:nowrap; text-overflow: ellipsis;" :span="22">{{scope.row.sjmc}}</el-col>
              <el-col :span="2" v-if="scope.row.ksmc">
                <el-popover trigger="hover" placement="top">
                  <div style="max-width: 1000px">该试卷正被<span style="color: blue; font-weight: bold">{{scope.row.ksmc}}</span>考试引用</div>
                  <i  slot="reference" class="el-icon-more"></i>
                </el-popover>
              </el-col>
            </template>
          </el-table-column>
          <el-table-column label="试卷类型" width="130" prop="flmc"/>
          <el-table-column label="总分" width="60" prop="sjzf" align="right"/>
          <el-table-column label="组卷方式" width="155" prop="zjfsms" align="center"/>
          <el-table-column label="创建人" width="120" prop="cjrmc"/>
          <el-table-column label="创建时间" width="155" prop="cjsj"/>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <el-button size="mini" @click="toExamPaperEdit(scope.$index, scope.row)" style="border-color:blue">
                编辑</el-button>
                <el-button size="mini" @click="toExamPaperCopy(scope.$index, scope.row)" type="primary">
                复制</el-button>
              <el-button size="mini" @click="handleRemove(scope.$index, scope.row)" :disabled="scope.row.kszt && scope.row.kszt !== null" type="danger">
                删除</el-button>
            <el-button size="mini" @click="toExamSetting(scope.$index, scope.row)" :disabled="scope.row.kszt && scope.row.kszt !== null" type="primary">
                创建考试</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum">
          </el-pagination>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import myHeader from '@/components/myHeader'
import classify from '@/components/select/classify'
import classifyTree from '@/components/tree/classifyTree'
import classifyTreeEdit from '@/components/tree/classifyTreeEdit'
import * as examPaper from '@/api/examPaper'
export default {
  data () {
    return {
      showDialog: false,
      flglDialogVisible: false,
      form: {
        sjmc: '',
        flbhList: []
      },
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,
      tableData: []
    }
  },
  components: {
    myHeader,
    classify,
    classifyTree,
    classifyTreeEdit
  },
  methods: {
    // 创建考试
    goCreateSurvey () {
      this.$router.push({
        path: '/exam/add'
      })
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.query(this.currentPage)
    },
    handleCurrentChange (val) {
      this.query(val)
    },
    // 查询
    query (currentPage = 1) {
      this.currentPage = currentPage
      const params = { pageNo: this.currentPage, pageSize: this.pageSize }
      params.sjmc = this.form.sjmc
      params.flbhs = this.form.flbhList.join(',')
      examPaper.getList(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableData = data.list
          this.totalNum = data.count
        })
      })
    },
    // 创建试卷
    toExamPaperAdd () {
      this.$router.push({
        path: '/examPaper/add'
      })
    },
    // 编辑
    toExamPaperEdit ($index, row) {
      if (row.kszt && row.kszt !== '0') {
        this.$message.warning('不能对试卷进行编辑，已经有进行中的考试使用了该试卷！')
        return
      }
      const query = {
        sjid: row.sjid
      }
      this.$router.push({
        path: '/examPaper/add',
        query: query
      })
    },
    toExamPaperCopy ($index, row) {
      const params = {
        sjid: row.sjid
      }
      examPaper.copy(params).then(res => {
        this.$http.callback(res, () => {
          this.$message({
            message: '试卷复制成功！点击「查询」按钮刷新列表',
            type: 'success',
            duration: 4000
          })
          // this.query()
        })
      })
    },
    // 删除
    handleRemove ($index, row) {
      if (row.ksid) {
        this.$message.warning('试卷已经绑定了考试，不能删除！')
        return
      }
      this.$confirm('确定需要删除选中试题吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          sjid: row.sjid
        }
        examPaper.remove(params).then(res => {
          this.$http.callback(res, () => {
            this.$message.success(res.msg)
            this.query(this.currentPage)
          })
        })
      }).catch(() => {})
    },
    // 创建考试
    toExamSetting ($index, row) {
      const query = {
        sjid: row.sjid
      }
      this.$router.push({
        path: '/exam/setting',
        query: query
      })
    }
  },
  mounted () {
    // 进入页面后进行查询
    this.query()
  }
}
</script>
